import { useGlobalStacks } from "@/state/globalStacks";
import { useBreakpoint } from "@/common/hooks";
import { BrandDiamond } from "./BrandMark";
import { useTimeSidebarToggle } from "./useSidebarToggle";

/**
 * The header's one time control: the brand mark and the current interval in a
 * single button that opens and closes the time sidebar.
 *
 * The mark shows only while that sidebar is off screen — collapsed on desktop,
 * or shut on mobile — because the sidebar carries the full brand in its own
 * header. `showInterval` is false on the routes that have no interval to name
 * (`/admin`, `/login`, `/record*`), leaving just the mark as the way back.
 */
export default function CurrentInterval({
  showInterval = true,
}: {
  showInterval?: boolean;
}) {
  const globalStacks = useGlobalStacks();
  const name = globalStacks.getName();
  const { isMd } = useBreakpoint();
  const { open, toggle } = useTimeSidebarToggle();

  const showMark = !isMd || !open;
  if (!showMark && !showInterval) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      title={`${open ? "Hide" : "Show"} time (⌘B)`}
      className="flex min-w-0 items-center gap-2 rounded-md px-2 py-1 hover:bg-accent cursor-pointer"
    >
      {showMark && <BrandDiamond />}
      {showInterval && (
        <span className="truncate font-mono text-[13px] text-muted-foreground">
          {name}
        </span>
      )}
      <span className="sr-only">{open ? "Hide" : "Show"} time sidebar</span>
    </button>
  );
}
